module.exports = __webpack_public_path__ + "img/elvis-fanday-87.739ab39a.jpg";